import { inject, Injectable } from '@angular/core';
import { ApiService, DialogService as CommonDialogService, Town } from '@portal/common';
import { Observable, switchMap } from 'rxjs';
import { CitiesDialogComponent } from '../dialogs/cities-dialog/cities-dialog.component';

export type CitiesDialogType = 'residential' | 'commercial' | 'dumpster';

export interface CitiesDialogData {
  towns: Town[];
  type?: CitiesDialogType;
}

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private commonDialogService = inject(CommonDialogService);
  private apiService = inject(ApiService);

  openTownsDialog(type?: CitiesDialogType): Observable<void> {
    return this.apiService.getTowns().pipe(
      switchMap((towns) =>
        this.commonDialogService.openDialog<void, CitiesDialogComponent, CitiesDialogData>(CitiesDialogComponent, {
          towns,
          type,
        }),
      ),
    );
  }
}
